import MuiButton from '@mui/material/Button';
import React from 'react';

/**
 * @deprecated Use Button from '@mui/material' or 'reactstrap' instead
 */
export default function Button(props) {
  return <MuiButton {...props} />;
}
